window.__assetPrefix__ = 'https://d257dg8me7m1ux.cloudfront.net/analytics-hub';